import * as React from 'react';
import * as API from './../../../../api/laas-api';
import { ShippingStoresApiResponse } from '../../../../api/types/shipping-stores';
import { ShippingRouteApiResponse } from '../../../../api/types/shipping-route';
import MDCSelect from '../../../../components/MDCSelect';

interface IRouteCalculatorProps {
    shippingLocations?: {
        source: string;
        destination: string;
    };
    handleSubmitRoute?: (route: ShippingRouteApiResponse) => void;
}

interface store {
    id: string;
    name: string;
    state: string;
}

class RouteCalculator extends React.Component<IRouteCalculatorProps> {
    constructor(props: IRouteCalculatorProps) {
        super(props);

        this.handleListChange = this.handleListChange.bind(this);
        this.handleCalculateRoute = this.handleCalculateRoute.bind(this);
        this.transformStoresToOptions = this.transformStoresToOptions.bind(this);
    }
    public state = {
        shippingLocations: this.props.shippingLocations
            ? this.props.shippingLocations
            : { source: '', destination: '' },
        source: '',
        destination: '',
        showPreview: false,
        allStoresList: [],
        sourceList: [],
        destList: [],
        route: {},
        selectOptions: [],
    };
    public componentDidMount() {
        this.handleGetStores();
    }
    private async handleCalculateRoute() {
        const shippingRoute: ShippingRouteApiResponse = await API.getRoutePrice(
            this.state.source,
            this.state.destination
        );
        if (shippingRoute) {
            this.setState({
                showPreview: true,
                route: shippingRoute,
            });
        }
        if (this.props.handleSubmitRoute) {
            this.props.handleSubmitRoute(shippingRoute);
        }
    }
    private async handleGetStores() {
        const stores: ShippingStoresApiResponse[] = await API.getStores();
        if (stores) {
            this.transformStoresToOptions(stores);
        }
    }
    private handleListChange(selectedStoreId: string, listType: string) {
        const filteredList = this.state.allStoresList.filter((store: any) => {
            return store.value !== selectedStoreId;
        });
        if (listType === 'source') {
            this.setState({
                source: selectedStoreId,
                destList: filteredList,
            });
        } else if (listType === 'destination') {
            this.setState({
                destination: selectedStoreId,
                sourceList: filteredList,
            });
        }
    }
    private transformStoresToOptions(stores: any[]) {
        const options: any = [];
        if (stores.length !== 0) {
            stores.unshift({ name: '', id: 0, state: '' });
            stores.map((store, index) => {
                const currentStore: store = store;
                options.push({
                    label: currentStore.name ? currentStore.name + ', ' + currentStore.state : '',
                    value: currentStore.id,
                    key: index,
                });
            });
        }
        this.setState({
            allStoresList: options,
            sourceList: options,
            destList: options,
        });
    }
    public render() {
        const routeButtonEnabled = this.state.source !== '' && this.state.destination !== '';
        const onChangeSource = (event: any) => {
            this.handleListChange(event.target.value, 'source');
        };
        const onChangeDestination = (event: any) => {
            this.handleListChange(event.target.value, 'destination');
        };
        const currentRoute: any = this.state.route;
        return (
            <section id="laas-route-calculator" className="laas-route-calculator">
                <div className="laas-destination-selection">
                    <MDCSelect
                        id="route-calculator--source-select"
                        value={this.state.source}
                        label="From"
                        options={this.state.sourceList}
                        onChange={onChangeSource}
                        className="laas-select-field"
                    />
                    <MDCSelect
                        id="route-calculator--destination-select"
                        value={this.state.destination}
                        label="To"
                        options={this.state.destList}
                        onChange={onChangeDestination}
                        className="laas-select-field"
                    />
                    <button
                        className="laas-route-calculator-cta"
                        onClick={this.handleCalculateRoute}
                        disabled={!routeButtonEnabled}
                    >
                        <span className="svg-icon-wrapper">get quote</span>
                    </button>
                </div>
                {this.state.showPreview && (
                    <div className="laas-route-calculator-price-preview">
                        <span className="rc-svg-vertical">
                            <svg
                                id="a02d8275-3927-48e7-b667-09050800da0f"
                                data-name="Layer 1"
                                width="16"
                                height="182.5"
                                viewBox="0 0 16 182.5"
                            >
                                <defs>
                                    <mask
                                        id="f67c8a03-eff5-420d-a927-ba570f5b4937"
                                        x="0"
                                        y="166.5"
                                        width="16"
                                        height="16"
                                        maskUnits="userSpaceOnUse"
                                    >
                                        <g transform="translate(3 -0.5)">
                                            <g id="b9110eca-dec1-4e1d-b63a-78415fd6ba36" data-name="mask-2">
                                                <path
                                                    id="b09a4f7d-18f1-4797-afbe-3a51aac778d1"
                                                    data-name="path-1"
                                                    d="M5,168.33A4.67,4.67,0,0,0,.33,173c0,3.5,4.67,8.67,4.67,8.67S9.67,176.5,9.67,173A4.67,4.67,0,0,0,5,168.33Zm0,6.34A1.67,1.67,0,1,1,6.67,173,1.67,1.67,0,0,1,5,174.67Z"
                                                    fill="#fff"
                                                    fillRule="evenodd"
                                                />
                                            </g>
                                        </g>
                                    </mask>
                                </defs>
                                <g id="b03d539e-40af-4bdf-b63d-a0a9d485c048" data-name="from-to-path">
                                    <g id="a167d7da-3971-4003-a0d2-bf7a77a93459" data-name="path-line">
                                        <path
                                            id="f5dfa95c-05df-4d67-abda-708dcd2b307f"
                                            data-name="Path-3"
                                            d="M4.5,17V160"
                                            transform="translate(3 -0.5)"
                                            fill="none"
                                            stroke="#979797"
                                            strokeDasharray="5"
                                        />
                                        <circle
                                            id="f5f35d8c-5f33-48c2-9c2a-52243f95409a"
                                            data-name="Oval-3"
                                            cx="8"
                                            cy="4.5"
                                            r="4"
                                            fill="none"
                                            stroke="#979797"
                                        />
                                        <g id="af2a0ec3-7e89-44eb-a603-88003c812930" data-name="place">
                                            <path
                                                d="M5,168.33A4.67,4.67,0,0,0,.33,173c0,3.5,4.67,8.67,4.67,8.67S9.67,176.5,9.67,173A4.67,4.67,0,0,0,5,168.33Zm0,6.34A1.67,1.67,0,1,1,6.67,173,1.67,1.67,0,0,1,5,174.67Z"
                                                transform="translate(3 -0.5)"
                                            />
                                        </g>
                                        <g mask="url(#f67c8a03-eff5-420d-a927-ba570f5b4937)">
                                            <rect
                                                id="ba7ba090-9d99-4ddc-8827-90bfdc99388b"
                                                data-name="color"
                                                y="166.5"
                                                width="16"
                                                height="16"
                                                fill="#9e9e9e"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </span>
                        <div className="laas-route-calculator-price-description">
                            <div className="source">
                                {currentRoute.sourceStoreName + ', ' + currentRoute.sourceStoreState}
                            </div>
                            <div className="laas-route-calculator-svg-container-desktop">
                                <span className="rc-svg-horizontal">
                                    <svg
                                        id="bf5e8b92-8b05-4c1e-8222-336f08cc620d"
                                        data-name="Layer 1"
                                        width="184.5"
                                        height="30.5"
                                        viewBox="0 0 184.5 30.5"
                                    >
                                        <defs>
                                            <mask
                                                id="a66bb121-a032-4817-912a-ddc57e2cef4a"
                                                x="168.5"
                                                y="14.5"
                                                width="16"
                                                height="16"
                                                maskUnits="userSpaceOnUse"
                                            >
                                                <g transform="translate(-0.5 -0.5)">
                                                    <g id="a68f611f-41b0-48af-a0ad-44ecb4b260b9" data-name="mask-2">
                                                        <path
                                                            id="ac016580-821b-4d54-a289-10f6c63a3a06"
                                                            data-name="path-1"
                                                            d="M177,16.33A4.67,4.67,0,0,0,172.33,21c0,3.5,4.67,8.67,4.67,8.67s4.67-5.17,4.67-8.67A4.67,4.67,0,0,0,177,16.33Zm0,6.34A1.67,1.67,0,1,1,178.67,21,1.67,1.67,0,0,1,177,22.67Z"
                                                            fill="#fff"
                                                            fillRule="evenodd"
                                                        />
                                                    </g>
                                                </g>
                                            </mask>
                                        </defs>
                                        <g
                                            id="b96c45a2-dfee-4a61-a148-85a0adb4ba7b"
                                            data-name="laas future-poss 02-copy-7"
                                        >
                                            <g id="ab77cba5-cc20-4b05-aa82-258558045225" data-name="results-set">
                                                <g id="bc339653-3555-4e8e-bdd2-5c241de2a4cf" data-name="Group">
                                                    <g id="b007c13f-0d85-4d1c-8e38-a648cc3b1c9d" data-name="path">
                                                        <path
                                                            id="b73e14dc-4215-4655-98b9-2eba8382e92d"
                                                            data-name="Path-3"
                                                            d="M15,16Q45,1,90.48,1T167,16"
                                                            transform="translate(-0.5 -0.5)"
                                                            fill="none"
                                                            stroke="#979797"
                                                            strokeDasharray="5"
                                                        />
                                                        <circle
                                                            id="a31e5d47-e81a-4318-b12a-8453e61eb4af"
                                                            data-name="Oval-3"
                                                            cx="5.5"
                                                            cy="22.5"
                                                            r="5"
                                                            fill="none"
                                                            stroke="#979797"
                                                        />
                                                        <g id="f6303a2a-8b78-4dd4-88aa-18ddb22b0c5a" data-name="place">
                                                            <path
                                                                d="M177,16.33A4.67,4.67,0,0,0,172.33,21c0,3.5,4.67,8.67,4.67,8.67s4.67-5.17,4.67-8.67A4.67,4.67,0,0,0,177,16.33Zm0,6.34A1.67,1.67,0,1,1,178.67,21,1.67,1.67,0,0,1,177,22.67Z"
                                                                transform="translate(-0.5 -0.5)"
                                                            />
                                                        </g>
                                                        <g mask="url(#a66bb121-a032-4817-912a-ddc57e2cef4a)">
                                                            <rect
                                                                id="f41e51ba-a96d-491b-a1e4-202433f31e71"
                                                                data-name="color"
                                                                x="168.5"
                                                                y="14.5"
                                                                width="16"
                                                                height="16"
                                                                fill="#9e9e9e"
                                                            />
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                                <div className="price-text">${currentRoute.totalPrice}*</div>
                            </div>
                            <div className="destination">
                                {currentRoute.destinationStoreName + ', ' + currentRoute.destinationStoreState}
                            </div>
                        </div>
                    </div>
                )}
            </section>
        );
    }
}

export default RouteCalculator;
